import InfoBlocks from '@/components/InfoBlocks'
import { classNames } from '@/util/tailwindHelpers'

export const ConvertPreviewStats = ({
  points,
  potential_points,
  potential_rank,
  className
}: {
  points: number
  potential_points: number
  potential_rank: number
  className?: string
}) => {
  return (
    <InfoBlocks
      className={classNames('mt-1', className)}
      orphansOnTop
      definitions={[
        {
          label: 'Total Points Converting',
          value: {
            type: 'numeric',
            value: points,
            color: 'arcade'
          },
          valueIcon: {
            name: 'arcade'
          }
        },
        {
          label: (
            <span>
              New Potential Rank<sup>*</sup>
            </span>
          ),
          value: {
            type: 'numeric',
            value: potential_rank
          },
          valueIcon: {
            name: 'trophy',
            color: 'arcade'
          }
        },
        {
          label: 'New Season Score',
          value: {
            type: 'numeric',
            value: potential_points
          },
          valueIcon: {
            name: 'arcade'
          }
        }
      ]}
    />
  )
}
